// Mock data for CAF Inc website
// This data can be replaced with CRM webhook integration later

// ============================================
// DEFAULT IMAGES (Unsplash placeholders until real photos are uploaded via Admin)
// ============================================

// Installation Photos (Default placeholder images)
export const realProjectImages = {
  // Vinyl Fence Installations
  vinyl: {
    highlandUniversalTop: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
    coastalCedarPrivacy: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
    hazelnutPrivacy: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop',
  },
  // Recent Project
  recentProjects: {
    queenstreetEdited: 'https://images.unsplash.com/photo-1565953522043-baea26b83b7e?w=800&h=600&fit=crop',
  },
  // Chain Link
  chainLink: {
    gateWithPrivacySlats: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=800&h=600&fit=crop',
  },
  // Wood
  wood: {
    standardWoodGate: 'https://images.unsplash.com/photo-1584284030207-eb240185c5dd?w=800&h=600&fit=crop',
  }
};

// Product/Hardware Images
export const realProductImages = {
  // Chain Link Products
  chainLink: {
    blackPlasticMesh: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=400&fit=crop',
  },
  // Vinyl Products & Posts
  vinyl: {
    fortress4x4: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop',
    veka2: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop',
    signatureColours: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop',
  },
  // Hardware
  hardware: {
    lokkLatch: 'https://images.unsplash.com/photo-1621922688758-e2d44a06e4f3?w=400&h=400&fit=crop',
    vinylWoodHinge: 'https://images.unsplash.com/photo-1621922688758-e2d44a06e4f3?w=400&h=400&fit=crop',
    vinylHinge: 'https://images.unsplash.com/photo-1621922688758-e2d44a06e4f3?w=400&h=400&fit=crop',
    vinylLatch: 'https://images.unsplash.com/photo-1621922688758-e2d44a06e4f3?w=400&h=400&fit=crop',
    woodHardware: 'https://images.unsplash.com/photo-1584284030207-eb240185c5dd?w=400&h=400&fit=crop',
  }
};

// Supplier Logos for brand recognition - Using uploaded logos
export const supplierLogos = {
  veka: '/logos/suppliers/veka.png',
  catalyst: '/logos/suppliers/catalyst-fence-solutions.jpg',
  rona: '/logos/suppliers/rona.jpg',
  directFencing: '/logos/suppliers/dfs.png',
  ameristar: '/logos/suppliers/ameristar.jpg',
  atlas: '/logos/suppliers/atlas-hardware.png',
  malden: '/logos/suppliers/malden-metals.png',
  dlr: '/logos/suppliers/dlr.jpg',
  melcor: '/logos/suppliers/melcor.jpg',
  vekaDualedge: '/logos/suppliers/veka-dualedge.png',
  vekaRecycle: '/logos/suppliers/veka-recycle.png',
  wcb: '/logos/badges/wcb-alberta.jpg',
};

// Placeholder images for services (to be replaced with actual project photos)
export const placeholderImages = {
  // Property Services Images
  landscape: [
    "https://images.unsplash.com/photo-1661133732576-6140941d5421?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1703432043433-3bb86c844968?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1747548747539-f523abfe6982?w=800&h=600&fit=crop"
  ],
  snow: [
    "https://images.unsplash.com/photo-1616128025408-901b4af64d13?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1585786124856-e0713a837736?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1546989483-cd6296a3e83b?w=800&h=600&fit=crop"
  ],
  parking: [
    "https://images.unsplash.com/photo-1697813165600-36bdc8f2ef7e?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1740479229028-c899cd33e34a?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1743521272571-14f5e3029de5?w=800&h=600&fit=crop"
  ],
  signage: [
    "https://images.unsplash.com/photo-1761470833861-aa6e0040e317?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1762542501470-ba35e8d732b5?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1766804626935-93b641ebf57e?w=800&h=600&fit=crop"
  ],
  // Fencing Images - Real CAF project photos
  fence: [
    "https://lh3.googleusercontent.com/d/1uc6JvLPKcpgIP2DA3fQYpAUCaTjkrKYa",
    "https://lh3.googleusercontent.com/d/1IfrS1U4lz1tMg4ib6O-ZdB6Dqp-JaZGb",
    "https://lh3.googleusercontent.com/d/1-U8RKCnrIaQqMkPUpGQSAcF909p89upW"
  ],
  // Generic commercial property
  commercial: [
    "https://images.unsplash.com/photo-1759753985489-11719e67dc7a?w=800&h=600&fit=crop",
    "https://images.unsplash.com/photo-1550291647-de91ea82e3b4?w=800&h=600&fit=crop"
  ]
};

export const companyInfo = {
  fence: {
    name: "Central Alberta Fencing Inc",
    shortName: "CAF Fencing",
    phone: "(403) 986-5484",
    email: "fence@cafinc.ca",
    tagline: "Supply & Installation of Residential and Commercial Fence",
    description: "We specialize in vinyl, wood, ornamental, and chain link fencing solutions for both residential and commercial properties across Central Alberta.",
    logo: "https://customer-assets.emergentagent.com/job_dual-biz-landing/artifacts/9znre4x8_Color%20logo%20-%20no%20background.png"
  },
  propertyServices: {
    name: "CAF Property Services",
    shortName: "CAF Property Services",
    phone: "(587) 877-0293",
    email: "dispatch@cafinc.ca",
    tagline: "Commercial Exterior Maintenance Experts",
    description: "We provide comprehensive commercial exterior maintenance including landscape maintenance, curb repair, parking lot repair, crack sealing, signage, and snow removal.",
    logo: "https://customer-assets.emergentagent.com/job_dual-biz-landing/artifacts/5if9ig1c_Color%20logo%20-%20no%20background.png"
  },
  shared: {
    address: {
      street: "116-25 Belich Crescent",
      city: "Red Deer County",
      province: "Alberta",
      postal: "T4S 2K5",
      full: "116-25 Belich Crescent, Red Deer County, Alberta T4S 2K5"
    },
    phone: "(866) 986-5484",
    email: "hello@cafinc.ca",
    website: "www.cafinc.ca",
    adminLoginUrl: "/admin",
    fencePortalUrl: "https://cafinc.mccsys.ca/portal-chooser",
    psPortalUrl: "https://cafps.mccsys.ca/portal-chooser",
    crmUrl: "https://cafinc.mccsys.ca",
    fenceBookingUrl: "https://mccsys.ca/public/book/central-alberta-fencing-inc-la24fw",
    fenceStoreUrl: "https://mccsys.ca/store/central-alberta-fencing-inc-la24fw"
  }
};

export const fenceServices = [
  {
    id: 1,
    slug: "chain-link",
    title: "Chain Link Fencing",
    shortDescription: "Durable and cost-effective chain link fencing available in galvanized, black, and white (special order). Ideal for residential, commercial, and industrial applications.",
    description: "Chain link fencing provides an economical and durable solution for securing properties of all sizes. We offer galvanized chain link as our standard option, with black vinyl-coated chain link for a sleek, modern look. White chain link is available as a special order for unique applications. Whether you need perimeter security, pet containment, or property boundaries, chain link is a versatile and reliable choice built to handle Central Alberta's climate.",
    features: ["Galvanized standard", "Black vinyl-coated", "White (special order)", "Multiple heights"],
    benefits: [
      "Most cost-effective fencing solution available",
      "Galvanized finish resists rust and corrosion",
      "Black vinyl-coated option for a modern aesthetic",
      "White available by special order",
      "Extremely durable in Alberta's harsh winters",
      "Quick installation with minimal disruption"
    ],
    applications: ["Residential yards", "Commercial properties", "Industrial perimeters", "Sports facilities", "Pet enclosures", "Construction sites"],
    gallery: [
      { id: 1, url: "https://lh3.googleusercontent.com/d/1dej7dDsE_oSn7Yje96qqraYJvX9wyGA9", alt: "Chain link gate with privacy slats - CAF installation" },
      { id: 2, url: "https://lh3.googleusercontent.com/d/1oBn-TTXRQuZo2H5BQKHu6QibKhrLHFyD", alt: "4' Black plastic mesh fencing" },
      { id: 3, url: "https://images.unsplash.com/photo-1749229279373-6c3d1368ca15?w=800&h=600&fit=crop", alt: "Chain link fence with trees" }
    ],
    // Extended chain link data
    specs: {
      gauges: [
        { size: "11 Gauge", use: "Residential - Standard" },
        { size: "9 Gauge", use: "Commercial - Heavy duty" },
        { size: "6 Gauge", use: "Industrial - Maximum strength" }
      ],
      meshSizes: ["2 inch", "2-1/4 inch", "2-3/8 inch"],
      heights: ["4'", "5'", "6'", "8'", "10'", "12'"],
      finishes: [
        { name: "Galvanized", description: "Hot-dipped zinc coating for corrosion resistance", color: "#A8A8A8", bgColor: "#E5E5E5", innerColor: "#C0C0C0", note: "Standard" },
        { name: "Black Vinyl", description: "PVC-coated for a modern look and extra durability", color: "#1a1a1a", bgColor: "#2d2d2d", innerColor: "#000000", note: null },
        { name: "White Vinyl", description: "Clean aesthetic for specialty applications", color: "#f5f5f5", bgColor: "#fafafa", innerColor: "#ffffff", note: "Special Order" }
      ],
      addons: ["Privacy slats", "Barbed wire", "Razor ribbon", "Windscreen", "Top rail", "Bottom rail", "Gates (swing/slide)", "Post caps"]
    },
    categories: {
      residential: {
        title: "Residential Chain Link",
        description: "Perfect for homeowners who want an affordable, durable fence for property boundaries, pet containment, and backyard security.",
        applications: ["Backyard enclosures", "Dog runs", "Garden protection", "Pool fencing", "Property boundaries"],
        heights: ["4'", "5'", "6'"],
        features: [
          "11-gauge galvanized wire for residential durability",
          "Black vinyl-coated option blends with landscaping",
          "2-inch mesh keeps pets safely contained",
          "Walk-through and drive-through gate options",
          "Can be combined with privacy slats"
        ]
      },
      commercial: {
        title: "Commercial Chain Link",
        description: "Heavy-duty chain link for businesses, industrial sites, and high-security applications requiring strength and longevity.",
        applications: ["Construction sites", "Industrial perimeters", "Sports facilities", "School yards", "Warehouse compounds", "Equipment storage"],
        heights: ["6'", "8'", "10'", "12'"],
        features: [
          "9-gauge or 6-gauge wire for maximum strength",
          "Heavier framework for high-wind areas",
          "Barbed wire or razor ribbon options",
          "Sliding gate systems for vehicle access",
          "Meets security specifications and codes"
        ]
      }
    }
  },
  {
    id: 2,
    slug: "wood",
    title: "Wood Fencing",
    shortDescription: "Classic wood fencing available in pressure treated and cedar options. Beautiful, natural fencing that adds privacy and character to your property.",
    description: "Wood fencing remains one of the most popular choices for its timeless appeal and natural warmth. We specialize in two premium wood options: pressure treated lumber from Rona for durability and long-lasting protection against rot and insects, and Western Red Cedar for its natural beauty, aromatic qualities, and superior weather resistance. Both options can be customized to suit any style, from privacy fences to decorative pickets.",
    features: ["Pressure treated", "Cedar options", "Custom designs", "Privacy & picket styles"],
    benefits: [
      "Pressure treated lumber resists rot, decay, and insects",
      "Cedar offers natural weather resistance and beauty",
      "Easily customizable to any height or style",
      "Can be stained or painted any color",
      "Classic look that adds property value",
      "Ideal for privacy and decorative applications"
    ],
    applications: ["Privacy fencing", "Backyard enclosures", "Decorative borders", "Residential properties", "Acreage properties", "Commercial screening"],
    gallery: [
      { id: 1, url: "https://lh3.googleusercontent.com/d/1k9kCEWhpuWtYx7Tg192GMctuJQ12KV2q", alt: "Standard wood gate - CAF installation" },
      { id: 2, url: "https://lh3.googleusercontent.com/d/1VjReoTaX40vBi4MmmvJjzwoEpfjYXtxz", alt: "Wood fence hardware" },
      { id: 3, url: "https://images.unsplash.com/photo-1748908271592-d9d5690b288b?w=800&h=600&fit=crop", alt: "Cedar wood fence" }
    ],
    // Extended wood fence data with Rona supplier info
    suppliers: {
      rona: {
        name: "Rona Pressure Treated Lumber",
        description: "We source our pressure-treated lumber from Rona, featuring MicroPro technology with copper azole preservative. This advanced treatment protects against rot, decay, and insect damage while being safer for residential use.",
        website: "https://www.rona.ca/en/building-materials/lumber-composites/pressure-treated-lumber",
        treatment: "MicroPro copper azole - a revolutionary preservative technology that is effective against fungal decay, rot, and insect attack",
        useCategory: "UC3A Above Ground - Perfect for fence boards, pickets, rails, and posts above ground contact",
        warranty: "Limited Lifetime Warranty against rot and decay when used according to specifications",
        features: [
          "MicroPro technology",
          "Copper azole preservative",
          "UC3A rated",
          "Kiln-dried after treatment",
          "Low VOC emissions",
          "Safe for residential use"
        ],
        commonSizes: [
          { size: "2x4x8", use: "Rails, bracing" },
          { size: "2x6x8", use: "Cap rails, wider pickets" },
          { size: "1x6x6", use: "Standard fence boards" },
          { size: "4x4x8", use: "Standard posts" },
          { size: "6x6x8", use: "Heavy-duty posts, corners" }
        ]
      },
      cedar: {
        name: "Western Red Cedar",
        description: "Western Red Cedar is nature's premium fencing material. Its natural oils provide built-in resistance to moisture, decay, and insects without the need for chemical treatment. Cedar weathers to a beautiful silver-grey patina or can be stained to maintain its rich reddish-brown color.",
        benefits: [
          { title: "Natural Durability", description: "Contains natural oils that resist rot, decay, and insect damage" },
          { title: "Dimensional Stability", description: "Low shrinkage factor means less warping, twisting, and splitting" },
          { title: "Beautiful Appearance", description: "Rich, warm tones that can be left natural or stained" },
          { title: "Lightweight", description: "Easier to work with and install than pressure-treated alternatives" }
        ],
        characteristics: ["Naturally rot-resistant", "Aromatic", "Low shrinkage", "Easy to stain", "Lightweight", "Eco-friendly"]
      }
    },
    styles: [
      { name: "Full Privacy", description: "Board-on-board or solid panel construction for complete seclusion", features: ["6' standard height", "No gaps", "Maximum privacy"], image: "https://lh3.googleusercontent.com/d/1k9kCEWhpuWtYx7Tg192GMctuJQ12KV2q" },
      { name: "Semi-Privacy", description: "Spaced boards or shadowbox design for airflow while maintaining privacy", features: ["1-2\" gaps", "Airflow", "Modern look"], image: "https://images.unsplash.com/photo-1678020635276-0d2445bb92ca?w=800&h=600&fit=crop" },
      { name: "Picket Fence", description: "Classic pointed or dog-ear pickets for a traditional look", features: ["3-4' height", "Decorative", "Classic style"], image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop" },
      { name: "Horizontal Slat", description: "Modern horizontal board design for a contemporary aesthetic", features: ["Clean lines", "Contemporary", "Custom spacing"], image: "https://images.unsplash.com/photo-1748908271592-d9d5690b288b?w=800&h=600&fit=crop" },
      { name: "Lattice Top", description: "Solid privacy panels with decorative lattice topper", features: ["Added height", "Decorative", "Light filtering"], image: "https://images.unsplash.com/photo-1595521329820-153efb77f59e?w=800&h=600&fit=crop" },
      { name: "Post & Rail", description: "Open design for property boundaries and rural properties", features: ["2-4 rails", "Open view", "Acreage friendly"], image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&h=600&fit=crop" }
    ],
    specs: {
      dimensions: [
        { size: "1x6", use: "Fence boards/pickets" },
        { size: "2x4", use: "Rails" },
        { size: "2x6", use: "Cap rails" },
        { size: "4x4", use: "Standard posts" },
        { size: "6x6", use: "Heavy posts/corners" }
      ],
      heights: ["4'", "5'", "6'", "8'"],
      treatmentDetails: [
        "MicroPro copper azole preservative",
        "UC3A rated for above-ground use",
        "Kiln-dried after treatment (KDAT)",
        "Low environmental impact",
        "Safe for residential landscaping contact"
      ],
      maintenanceTips: [
        "Apply stain or sealant within 6 months of installation",
        "Re-stain every 2-3 years for optimal protection",
        "Inspect annually for loose boards or damaged posts",
        "Keep vegetation trimmed away from fence line",
        "Clean with mild soap and water as needed"
      ]
    }
  },
  {
    id: 3,
    slug: "vinyl",
    title: "Vinyl Fencing",
    shortDescription: "Premium VEKAfence and Catalyst Newbury vinyl fencing. Privacy, semi-privacy, picket, pool, and ranch rail styles in 25+ colours. Custom CNC fabrication available.",
    description: "We supply and install premium vinyl fencing from two industry-leading manufacturers: VEKAfence and Catalyst Fence Solutions (Newbury line). Both product lines are engineered to outperform and outlast other fence materials, meeting ASTM standards for impact, weather, and wind resistance. With our in-house CMM CNC routing equipment, we offer custom heights, drops, and design work that most fence companies can't match. Vinyl fencing is the ultimate low-maintenance solution — the only upkeep your fence needs is a yearly hose-off with soap and water.",
    features: ["VEKAfence & Catalyst Newbury", "25+ colour options", "CNC custom fabrication", "Privacy, semi-privacy, picket & ranch rail"],
    benefits: [
      "Two premium brands: VEKAfence and Catalyst Newbury",
      "Custom CNC routing for any height, drop, or design",
      "Never needs painting, staining, or sealing",
      "Won't rot, warp, crack, or splinter",
      "ASTM tested for impact, weather, and wind",
      "Limited Lifetime Warranty on both product lines",
      "Eco-friendly VEKA DualEdge technology",
      "Catalyst GlideLock, SolarGuard, and StayStraight innovations"
    ],
    applications: ["Residential backyards", "Pool enclosures", "Commercial properties", "Privacy screening", "Decorative boundaries", "Acreage properties", "Semi-privacy screening", "Ranch & acreage rail fencing"],
    gallery: [
      { id: 1, url: "https://lh3.googleusercontent.com/d/1uc6JvLPKcpgIP2DA3fQYpAUCaTjkrKYa", alt: "5' Highland Universal Top vinyl fence - CAF installation" },
      { id: 2, url: "https://lh3.googleusercontent.com/d/1IfrS1U4lz1tMg4ib6O-ZdB6Dqp-JaZGb", alt: "6' Coastal Cedar Privacy vinyl fence - CAF installation" },
      { id: 3, url: "https://lh3.googleusercontent.com/d/1KQWjEisc2abetDdxVNR3vwwQaqyygZFH", alt: "6' Hazelnut Privacy vinyl fence - CAF installation" }
    ],
    // Extended vinyl data for the detail page
    brands: {
      veka: {
        name: "VEKAfence",
        tagline: "Structural integrity and design flexibility",
        website: "https://www.vekaolp.com/vekafence/",
        colorSelectorUrl: "https://www.vekaolp.com/colors/color-selectors/vekafence-color-selector/",
        fenceStyles: [
          { name: "Privacy Fence", description: "Complete seclusion and sophistication. Available in multiple heights and colour options." },
          { name: "Semi-Privacy Fence", description: "Optimal quality and durability with airflow. Multiple styles that provide the perfect level of seclusion." },
          { name: "Picket & Pool Fence", description: "Engineered for long-term performance. Meets fencing standards for pool safety with proper picket spacing." },
          { name: "Ranch Rail Fence", description: "Distinguished look for homes, agricultural, and commercial properties of any size." }
        ],
        colors: {
          standard: [
            { name: "White", swatch: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/color-swatches/white_res_1_1_w400.jpg" },
            { name: "Almond", swatch: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/color-swatches/almond_res_1_1_w400.jpg" },
            { name: "Khaki", swatch: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/color-swatches/khaki_res_1_1_w400.jpg" },
            { name: "Stone", swatch: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/color-swatches/stone-swatch_res_1_1_w400-2.png" }
          ],
          variegated: [
            { name: "White Variegated", swatch: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/color-swatches/white-variegated-color-swatch_res_1_1_w400.jpg" },
            { name: "Almond Variegated", swatch: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/color-swatches/almond-variegated-color-swatch_res_1_1_w400.jpg" },
            { name: "Khaki Variegated", swatch: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/color-swatches/khaki-variegated-color-swatch_res_1_1_w400.jpg" }
          ],
          signature: [
            { name: "Signature Espresso", swatch: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/espresso_extruded_res_1_1_w400-2.jpg" },
            { name: "Signature Cayenne", swatch: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/color-swatches/cayenne-swatch_res_1_1_w400.png" },
            { name: "Signature Hazelnut", swatch: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/color-swatches/hazelnut_res_1_1_w400.jpg" },
            { name: "Signature Storm", swatch: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/color-swatches/storm_res_1_1_w400.jpg" }
          ]
        },
        galleryImages: [
          { url: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/vekafence/hollywood-tan_res_1_1_w700.jpg", alt: "VEKA Privacy Fence" },
          { url: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/vekafence/fence-types/privacy/stone-privacy.jpg", alt: "VEKA Stone Privacy Fence" },
          { url: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/pinnacle-golden-oak-privacy-fence_res_1_1_w700.jpg", alt: "VEKA Golden Oak Privacy" },
          { url: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/vekafence/fence-types/picket/white-picket-pool-fence_res_1_1_w700-3.jpg", alt: "VEKA White Picket Pool Fence" },
          { url: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/ranch_rail_adj_res_1_1_w700.jpg", alt: "VEKA Ranch Rail Fence" },
          { url: "https://vekaprod-media.e-spirit.cloud/491f904a-9c9d-4745-9d26-b7bccef59c32/editorial_media/signature28_res_2_1_w800.jpg", alt: "VEKA Signature Cayenne Privacy" }
        ]
      },
      catalyst: {
        name: "Catalyst Newbury",
        tagline: "Solid Vertical Privacy — stands the test of time",
        website: "https://www.catalystfence.com/newbury",
        colors: {
          standard: [
            { name: "White", swatch: "https://www.catalystfence.com/wp-content/uploads/White.webp" },
            { name: "Sand", swatch: "https://www.catalystfence.com/wp-content/uploads/Sand.webp" },
            { name: "Clay", swatch: "https://www.catalystfence.com/wp-content/uploads/Clay.webp" },
            { name: "Gray", swatch: "https://www.catalystfence.com/wp-content/uploads/Gray-1.webp" }
          ],
          smoothWoodgrain: [
            { name: "Cypress", swatch: "https://www.catalystfence.com/wp-content/uploads/Cypress.webp" },
            { name: "Coastal Cedar", swatch: "https://www.catalystfence.com/wp-content/uploads/Coastal_Cedar.webp" },
            { name: "Dark Walnut", swatch: "https://www.catalystfence.com/wp-content/uploads/Dark_Walnut.webp" },
            { name: "Weathered Aspen", swatch: "https://www.catalystfence.com/wp-content/uploads/Weathered_Aspen.webp" }
          ],
          premiumWoodgrain: [
            { name: "Weathered Blend", swatch: "https://www.catalystfence.com/wp-content/uploads/Weathered_Blend.webp" },
            { name: "Sierra Blend", swatch: "https://www.catalystfence.com/wp-content/uploads/Sierra_Blend.webp" },
            { name: "Brazilian Blend", swatch: "https://www.catalystfence.com/wp-content/uploads/Brazilian_Blend.webp" },
            { name: "Arctic Blend", swatch: "https://www.catalystfence.com/wp-content/uploads/Artic_Blend.webp" }
          ]
        },
        topRails: [
          { name: "Apex", size: "2\" x 7\"" },
          { name: "Element Base", size: "1.5\" x 5.5\"" },
          { name: "Element LX", size: "2\" x 6\"" },
          { name: "Element Reserve", size: "1.75\" x 7\"" },
          { name: "Element Signature", size: "1.75\" x 5.5\"" },
          { name: "Vertex Grand", size: "2\" x 7\"" }
        ],
        innovations: [
          { name: "GlideLock\u00ae", description: "Locking infill boards for enhanced security" },
          { name: "SolarGuard\u00ae", description: "Advanced fade resistance technology" },
          { name: "StayStraight\u00ae", description: "Structural integrity that won't sag or bow" },
          { name: "TimberGrain\u2122", description: "Realistic woodgrain texture finish" }
        ],
        postCaps: ["Contemporary", "Federation", "New England", "Pyramid", "Internal", "Gothic", "Ball", "Solar"],
        documents: [
          { name: "Newbury Full SKU List", url: "https://www.catalystfence.com/wp-content/uploads/Newbury_Catalyst-VF-MF-Sku-Pages_CAT26-D-707822_6-26.pdf" },
          { name: "Vinyl Fence Warranty", url: "https://www.catalystfence.com/wp-content/uploads/Vinyl-Molded-Composite-Fence-Warranty_CAT26-D-634250_WEB.pdf" },
          { name: "Privacy Fence Installation Guide", url: "https://www.catalystfence.com/wp-content/uploads/CAT-BOM-34111483-Privacy-Vinyl-Fence-Kit-1-25-WEB.pdf" },
          { name: "Vinyl Privacy Gates Installation", url: "https://www.catalystfence.com/wp-content/uploads/CAT-Vinyl-Privacy-Gates_WEB.pdf" },
          { name: "Privacy & Picket Gates Installation", url: "https://www.catalystfence.com/wp-content/uploads/CAT-Vinyl_Privacy_Picket-Gates-Rev-1-25_WEB.pdf" },
          { name: "Premium LX TimberGrain Installation", url: "https://www.catalystfence.com/wp-content/uploads/Premium-LX-TimberGrain-Install-Instructions_EN_.pdf" }
        ],
        galleryImages: [
          { url: "https://www.catalystfence.com/wp-content/uploads/DogwoodHaven_6x8_Cypress_13.webp", alt: "Newbury Cypress along lakefront" },
          { url: "https://www.catalystfence.com/wp-content/uploads/73014530-Dogwood-White-InfluencerScene02.webp", alt: "Newbury White privacy fence" },
          { url: "https://www.catalystfence.com/wp-content/uploads/Newbury-SolidVerticalPrivacy-Standard-White.webp", alt: "Newbury Standard White" },
          { url: "https://www.catalystfence.com/wp-content/uploads/BOL_WI_July2024_RES_BuffChesterfield_002.webp", alt: "Newbury Buff privacy with landscaping" },
          { url: "https://www.catalystfence.com/wp-content/uploads/DogwoodHaven_6x8_Cypress_21.webp", alt: "Newbury Cypress outdoor living" },
          { url: "https://www.catalystfence.com/wp-content/uploads/BOL_WI_July2024_RES_BuffChesterfield_007.webp", alt: "Newbury poolside privacy" }
        ]
      }
    },
    specs: {
      standardHeights: ["5' (standard colours)", "6' (all colours)"],
      customNote: "Custom heights, drops, and designs available via in-house CNC routing",
      widths: ["6'", "8'"],
      cncInfo: {
        description: "We operate CMM CNC routing equipment in-house, allowing us to offer custom cuts, heights, drops, and design work on vinyl, aluminum, and composite fence materials. This capability means we can deliver customization most fence companies simply cannot offer.",
        website: "https://www.cmmbuilt.com/cmm-routing-series",
        capabilities: ["Custom heights beyond standard sizes", "Custom drops and transitions for sloped terrain", "Decorative top cuts and patterns", "Precision fabrication on vinyl, aluminum, and composite", "Quick turnaround on custom orders"]
      }
    }
  },
  {
    id: 4,
    slug: "ornamental",
    title: "Ornamental Fencing",
    shortDescription: "Elegant ornamental fencing from Direct Fencing Supply. Premium iron and aluminum options with Atlas gate hardware that add sophistication and security.",
    description: "We supply and install ornamental fencing from Direct Fencing Supply, one of the industry's most respected distributors. These premium ornamental fences combine beauty with security, offering elegant designs that enhance your property's curb appeal while providing reliable protection. We pair our ornamental fencing with Atlas gate hardware for smooth operation and lasting durability. Available in both iron and aluminum options with a range of styles, heights, and finishes to complement any property.",
    features: ["Direct Fencing Supply", "Atlas Hardware", "Iron & aluminum", "Custom designs"],
    benefits: [
      "Premium products from Direct Fencing Supply",
      "Elegant, upscale appearance for any property",
      "Excellent visibility while maintaining security",
      "Aluminum options that never rust",
      "Iron options for maximum strength and durability",
      "Wide range of styles, heights, and finishes available"
    ],
    applications: ["Front yard boundaries", "Pool safety fencing", "Commercial properties", "Acreage entrances", "Garden accents", "Property perimeters"],
    gallery: [
      { id: 1, url: "https://lh3.googleusercontent.com/d/1-U8RKCnrIaQqMkPUpGQSAcF909p89upW", alt: "500 Queen Street Elnora ornamental fence project - CAF installation" },
      { id: 2, url: "https://images.unsplash.com/photo-1768581242354-de0d045f0ca7?w=800&h=600&fit=crop", alt: "Ornamental fence finial detail" },
      { id: 3, url: "https://images.unsplash.com/photo-1595521329820-153efb77f59e?w=800&h=600&fit=crop", alt: "Decorative fence" }
    ],
    // Extended ornamental data with Direct Fencing Supply + Atlas + Ameristar
    suppliers: {
      directFencing: {
        name: "Direct Fencing Supply",
        description: "Direct Fencing Supply provides premium ornamental iron and aluminum fencing systems for residential and commercial applications. Their products combine traditional craftsmanship with modern manufacturing for exceptional quality and durability.",
        website: "https://directfencingsupply.com",
        logo: "/suppliers/direct-fencing-supply.png",
        products: [
          { name: "Residential Aluminum", description: "Lightweight, rust-free aluminum panels perfect for home boundaries and pool enclosures" },
          { name: "Commercial Aluminum", description: "Heavy-duty aluminum systems for businesses, parks, and institutional properties" },
          { name: "Ornamental Iron", description: "Classic wrought iron look with modern galvanized steel construction" },
          { name: "Industrial Steel", description: "Maximum security fencing for high-security commercial and industrial sites" }
        ]
      },
      ameristar: {
        name: "Ameristar Perimeter Security",
        description: "Ameristar is America's leading manufacturer of ornamental steel and aluminum fence and gate systems. Their products are manufactured in the USA, meet Buy American Act requirements, and feature industry-leading ProFusion welding and E-Coat protection.",
        website: "https://www.ameristarperimeter.com",
        logo: "/suppliers/ameristar.png",
        products: [
          { name: "Montage Commercial", description: "Commercial-grade welded steel fence that redefined the industry - 20 year warranty" },
          { name: "Montage Plus", description: "Premium residential ornamental steel with ProFusion welding technology" },
          { name: "Echelon", description: "Internally secured aluminum fence & gates - ideal for pool code compliance" },
          { name: "Aegis II", description: "Heavy industrial steel ornamental fence for high-security applications" }
        ],
        features: [
          "Made in USA",
          "Buy American Act Compliant",
          "11-Stage E-Coat Process",
          "ProFusion Welding",
          "20-Year Warranty"
        ]
      }
    },
    gateHardware: {
      atlas: {
        name: "Atlas Gate Hardware",
        tagline: "Premium Gate Hardware Solutions",
        description: "Atlas is Direct Fencing Supply's premier line of gate hardware, engineered for smooth operation, security, and long-term durability. From residential swing gates to commercial slide gates, Atlas hardware ensures your gates operate flawlessly for years.",
        website: "https://directfencingsupply.com/atlas-hardware",
        products: [
          { name: "Hinges", description: "Self-closing, adjustable tension hinges for swing gates" },
          { name: "Latches", description: "Magna-latch, gravity latches, and keyed lock options" },
          { name: "Closers", description: "Hydraulic and spring-loaded gate closers" },
          { name: "Slide Gate Hardware", description: "Track systems, rollers, and cantilever hardware" },
          { name: "Drop Rods", description: "Cane bolts and drop rods for double gates" },
          { name: "Locks", description: "Key locks, combination locks, and electronic access" }
        ],
        features: [
          "Corrosion-resistant finishes",
          "Adjustable tension settings",
          "Pool code compliant options",
          "Heavy-duty commercial grade",
          "Easy installation",
          "Weather sealed bearings"
        ]
      }
    },
    specs: {
      heights: ["4'", "5'", "6'"],
      finishes: [
        { name: "Black Semi Gloss", color: "#1a1a1a" }
      ],
      styles: [
        { name: "Classic Spear Top", description: "Traditional pointed finials for an elegant, timeless look", features: ["Most popular", "Traditional", "Decorative"] },
        { name: "Flat Top", description: "Modern, clean lines with no protruding finials", features: ["Contemporary", "Pet-friendly", "Pool code"] },
        { name: "Arched Panels", description: "Graceful curves add visual interest to fence lines", features: ["Decorative", "Custom heights", "Elegant"] },
        { name: "Puppy Picket", description: "Closer picket spacing at bottom to contain small pets", features: ["Pet-friendly", "Residential", "Security"] }
      ]
    }
  }
];

export const propertyServices = [
  {
    id: 1,
    slug: "landscape",
    title: "Landscape Maintenance",
    shortDescription: "Comprehensive landscape maintenance services to keep your commercial property looking pristine year-round.",
    description: "Our professional landscape maintenance services ensure your commercial property maintains its curb appeal throughout the year. From regular lawn care to seasonal clean-ups, we handle all aspects of landscape maintenance with attention to detail and professional expertise.",
    heroImage: "https://images.unsplash.com/photo-1558904541-efa843a96f01?w=1920&h=1080&fit=crop",
    features: ["Lawn care", "Garden maintenance", "Seasonal cleanups", "Irrigation management"],
    benefits: [
      "Regular mowing and edging services",
      "Fertilization and weed control programs",
      "Shrub and tree pruning",
      "Mulching and bed maintenance",
      "Spring and fall cleanup services",
      "Irrigation system monitoring and adjustments"
    ],
    applications: ["Office complexes", "Retail centers", "Industrial parks", "Multi-family properties", "Medical facilities", "Educational institutions"],
    gallery: [
      { id: 1, url: "https://images.unsplash.com/photo-1661133732576-6140941d5421?w=800&h=600&fit=crop", alt: "Commercial lawn maintenance" },
      { id: 2, url: "https://images.unsplash.com/photo-1703432043433-3bb86c844968?w=800&h=600&fit=crop", alt: "Professional landscaping" },
      { id: 3, url: "https://images.unsplash.com/photo-1747548747539-f523abfe6982?w=800&h=600&fit=crop", alt: "Green grass maintenance" }
    ],
    contractTypes: [
      { name: "Monthly Contract", description: "Fixed monthly rate for regular scheduled maintenance", icon: "calendar" },
      { name: "Seasonal Contract", description: "Spring through fall coverage with set service schedule", icon: "sun" },
      { name: "Per Visit", description: "Pay per service visit for flexible maintenance needs", icon: "clipboard" },
      { name: "Annual Agreement", description: "Year-round coverage with priority scheduling", icon: "file-check" }
    ],
    pricingNote: "Custom quotes based on property size, service frequency, and specific requirements."
  },
  {
    id: 2,
    slug: "curb-repair",
    title: "Curb Repair",
    shortDescription: "Professional curb repair and replacement services to maintain the safety and appearance of your property.",
    description: "Damaged curbs not only detract from your property's appearance but can also create safety hazards and liability issues. Our curb repair services restore damaged concrete curbing to like-new condition, ensuring your property looks professional and meets safety standards.",
    heroImage: "https://images.unsplash.com/photo-1621922688758-e2d44a06e4f3?w=1920&h=1080&fit=crop",
    features: ["Concrete restoration", "Full curb replacement", "ADA ramp compliance", "Yellow curb painting"],
    benefits: [
      "Restore damaged and crumbling curbs",
      "Prevent further deterioration",
      "Improve property appearance",
      "Ensure ADA compliance",
      "Professional curb painting and marking",
      "Cost-effective repairs vs full replacement"
    ],
    applications: ["Parking lots", "Commercial driveways", "Shopping centers", "Industrial facilities", "Municipal properties", "Residential complexes"],
    gallery: [
      { id: 1, url: "https://images.unsplash.com/photo-1743521272571-14f5e3029de5?w=800&h=600&fit=crop", alt: "Curb marking and repair" },
      { id: 2, url: "https://images.unsplash.com/photo-1697813165600-36bdc8f2ef7e?w=800&h=600&fit=crop", alt: "Parking lot curbs" },
      { id: 3, url: "https://images.unsplash.com/photo-1740479229028-c899cd33e34a?w=800&h=600&fit=crop", alt: "Commercial parking area" }
    ],
    contractTypes: [
      { name: "Project-Based", description: "One-time repair or replacement project", icon: "hammer" },
      { name: "Annual Inspection", description: "Yearly assessment with maintenance plan", icon: "clipboard" },
      { name: "Per Linear Foot", description: "Pricing based on curb length needing repair", icon: "ruler" }
    ],
    pricingNote: "Free site assessment. Quotes provided within 48 hours of inspection."
  },
  {
    id: 3,
    slug: "asphalt",
    title: "Parking Lot Repair",
    shortDescription: "Complete parking lot maintenance and repair services including patching, resurfacing, and line striping.",
    description: "A well-maintained parking lot is essential for business operations and customer safety. Our comprehensive asphalt and parking lot repair services address everything from minor crack filling to major resurfacing projects, extending the life of your pavement investment.",
    heroImage: "https://images.unsplash.com/photo-1573348722427-f1d6819fdf98?w=1920&h=1080&fit=crop",
    features: ["Pothole patching", "Asphalt resurfacing", "Sealcoating", "Drainage repair"],
    benefits: [
      "Professional pothole patching",
      "Asphalt overlay and resurfacing",
      "Parking lot line striping and marking",
      "ADA-compliant accessible spaces",
      "Speed bump installation",
      "Drainage improvements"
    ],
    applications: ["Commercial parking lots", "Shopping centers", "Office buildings", "Industrial facilities", "Multi-family properties", "Religious institutions"],
    gallery: [
      { id: 1, url: "https://images.unsplash.com/photo-1697813165600-36bdc8f2ef7e?w=800&h=600&fit=crop", alt: "Parking lot maintenance" },
      { id: 2, url: "https://images.unsplash.com/photo-1740479229028-c899cd33e34a?w=800&h=600&fit=crop", alt: "Commercial parking lot" },
      { id: 3, url: "https://images.unsplash.com/photo-1743521272571-14f5e3029de5?w=800&h=600&fit=crop", alt: "ADA parking marking" }
    ],
    contractTypes: [
      { name: "Project-Based", description: "One-time repair or full resurfacing project", icon: "hammer" },
      { name: "Annual Maintenance", description: "Scheduled inspections and preventive repairs", icon: "calendar" },
      { name: "Emergency Repair", description: "Urgent pothole and hazard repairs", icon: "alert-triangle" }
    ],
    pricingNote: "Pricing varies by project scope. Free estimates for all parking lot assessments."
  },
  {
    id: 4,
    slug: "crack-sealing",
    title: "Crack Sealing",
    shortDescription: "Preventive crack sealing services to extend the life of your asphalt surfaces and prevent further damage.",
    description: "Crack sealing is one of the most cost-effective preventive maintenance treatments for asphalt pavements. By sealing cracks early, you prevent water infiltration that leads to base failure, potholes, and costly repairs. Our professional crack sealing services extend pavement life significantly.",
    heroImage: "https://images.unsplash.com/photo-1621922688758-e2d44a06e4f3?w=1920&h=1080&fit=crop",
    features: ["Hot rubber sealing", "Crack routing", "Joint sealing", "Surface prep"],
    benefits: [
      "Prevents water damage to base materials",
      "Stops cracks from spreading",
      "Extends pavement life by years",
      "Cost-effective preventive maintenance",
      "Professional hot-pour application",
      "Quick application with minimal disruption"
    ],
    applications: ["Parking lots", "Driveways", "Private roads", "Loading areas", "Pathways", "Any asphalt surface"],
    gallery: [
      { id: 1, url: "https://images.unsplash.com/photo-1697813165600-36bdc8f2ef7e?w=800&h=600&fit=crop", alt: "Asphalt surface maintenance" },
      { id: 2, url: "https://images.unsplash.com/photo-1740479229028-c899cd33e34a?w=800&h=600&fit=crop", alt: "Parking lot repair" },
      { id: 3, url: "https://images.unsplash.com/photo-1579317472714-02c1640ea6d4?w=800&h=600&fit=crop", alt: "Asphalt maintenance" }
    ],
    contractTypes: [
      { name: "Per Linear Foot", description: "Pay based on total crack length sealed", icon: "ruler" },
      { name: "Annual Program", description: "Yearly crack sealing with inspection", icon: "calendar" },
      { name: "Project-Based", description: "Full parking lot crack sealing project", icon: "clipboard" }
    ],
    pricingNote: "Most cost-effective when combined with sealcoating services."
  },
  {
    id: 5,
    slug: "signage",
    title: "Signage",
    shortDescription: "Parking lot signage installation and maintenance - stop signs, handicap signs, no parking, and wayfinding.",
    description: "Proper parking lot signage is essential for traffic flow, safety compliance, and accessibility. We provide complete signage services for commercial parking facilities including stop signs, handicap parking signs, no parking zones, reserved parking, and directional wayfinding signs.",
    heroImage: "https://images.unsplash.com/photo-1586864387967-d02ef85d93e8?w=1920&h=1080&fit=crop",
    features: ["Stop signs", "Handicap signs", "No parking signs", "Directional signs"],
    benefits: [
      "Stop sign installation and replacement",
      "ADA-compliant handicap parking signs",
      "No parking and fire lane signs",
      "Reserved parking signage",
      "Speed limit and caution signs",
      "Wayfinding and directional signs"
    ],
    applications: ["Parking facilities", "Commercial buildings", "Industrial sites", "Retail centers", "Office complexes", "Medical facilities"],
    gallery: [
      { id: 1, url: "https://images.unsplash.com/photo-1761470833861-aa6e0040e317?w=800&h=600&fit=crop", alt: "Commercial parking signage" },
      { id: 2, url: "https://images.unsplash.com/photo-1762542501470-ba35e8d732b5?w=800&h=600&fit=crop", alt: "Building signage" },
      { id: 3, url: "https://images.unsplash.com/photo-1766804626935-93b641ebf57e?w=800&h=600&fit=crop", alt: "Commercial property signs" }
    ],
    contractTypes: [
      { name: "Per Sign", description: "Individual sign installation or replacement", icon: "signpost" },
      { name: "Full Property Package", description: "Complete signage overhaul for your property", icon: "package" },
      { name: "Maintenance Contract", description: "Regular inspection and upkeep of all signage", icon: "wrench" }
    ],
    pricingNote: "Custom quotes based on sign type, size, and installation requirements."
  },
  {
    id: 6,
    slug: "snow",
    title: "Snow Removal",
    shortDescription: "Professional commercial snow removal and ice management for Central Alberta's harshest winters.",
    description: "Central Alberta winters demand reliable snow removal services. Our professional snow removal team ensures your commercial property remains safe and accessible throughout the winter season. We use advanced tracking technology, provide photo documentation for insurance purposes, and offer flexible contract options to meet your specific needs.",
    heroImage: "https://images.unsplash.com/photo-1516912481808-3406841bd33c?w=1920&h=1080&fit=crop",
    features: ["24/7 availability", "Plowing & salting", "Sidewalk clearing", "Ice management"],
    benefits: [
      "24/7 emergency response capability",
      "Commercial-grade snow plowing equipment",
      "Sidewalk and entrance clearing",
      "Parking lot de-icing and salting",
      "Ice management programs with multiple products",
      "Photo documentation for insurance records",
      "Real-time GPS tracking of service vehicles",
      "Customer portal access for service requests"
    ],
    applications: ["Office buildings", "Retail centers", "Industrial facilities", "Medical facilities", "Multi-family properties", "Religious institutions"],
    gallery: [
      { id: 1, url: "https://images.unsplash.com/photo-1616128025408-901b4af64d13?w=800&h=600&fit=crop", alt: "Commercial snow plowing" },
      { id: 2, url: "https://images.unsplash.com/photo-1585786124856-e0713a837736?w=800&h=600&fit=crop", alt: "Snow removal equipment" },
      { id: 3, url: "https://images.unsplash.com/photo-1546989483-cd6296a3e83b?w=800&h=600&fit=crop", alt: "Winter snow clearing" }
    ],
    contractTypes: [
      { name: "Seasonal Contract", description: "Fixed monthly rate Nov-Apr, unlimited service calls", icon: "calendar", popular: true },
      { name: "Per Occurrence", description: "Pay only when we service your property", icon: "snowflake" },
      { name: "Per Push", description: "Per-visit pricing based on snowfall amount", icon: "truck" },
      { name: "Hourly Rate", description: "Equipment and operator hourly rates", icon: "clock" },
      { name: "Monthly Retainer", description: "Priority response with monthly minimum", icon: "shield" }
    ],
    serviceDetails: {
      sidewalks: {
        title: "Sidewalk & Entrance Clearing",
        items: ["Main entrances and exits", "Fire routes and emergency access", "Handicap ramps and accessibility paths", "Building perimeters", "Loading dock areas"]
      },
      parkingLots: {
        title: "Parking Lot Services",
        items: ["Full lot plowing and clearing", "Windrow removal and hauling", "Stacking and piling management", "Cart corral clearing", "Drive-thru lane maintenance"]
      },
      deicing: {
        title: "Sanding & De-Icing Products",
        items: [
          { name: "Rock Salt (Sodium Chloride)", description: "Standard de-icer, effective to -12°C" },
          { name: "7mm Aggregate/Sand Mix", description: "Traction control for icy surfaces" },
          { name: "Calcium Chloride", description: "Fast-acting, effective to -25°C" },
          { name: "Magnesium Chloride (Brine)", description: "Pre-treatment anti-icing solution" },
          { name: "Ice Melt Blend", description: "Commercial-grade multi-product blend" },
          { name: "Eco-Friendly Options", description: "Pet and plant-safe alternatives available" }
        ]
      },
      safetyOperations: {
        title: "Safety & Operations",
        items: [
          { name: "Emergency Lights on All Vehicles", description: "High-visibility amber/white LED light bars on every truck for safe nighttime operations" },
          { name: "Full Safety Gear for Staff", description: "High-vis vests, steel-toe boots, cold weather PPE, and safety training for all crew members" },
          { name: "Two-Way Radio Communication", description: "Real-time coordination between crews, supervisors, and dispatch for rapid response" },
          { name: "Supervisors On-Shift", description: "Dedicated supervisors on the road during every storm event monitoring crews and quality" },
          { name: "GPS Fleet Tracking", description: "Live vehicle tracking for route optimization and service verification" },
          { name: "24/7 Dispatch Center", description: "Round-the-clock monitoring and emergency response coordination" }
        ]
      },
      triggerTypes: {
        title: "Service Trigger Options",
        description: "Choose when we respond to your property",
        items: [
          { name: "1\" Trigger", description: "Service begins when accumulation reaches 1 inch - ideal for high-traffic retail and medical facilities", recommended: true },
          { name: "2\" Trigger", description: "Service begins at 2 inch accumulation - standard for most commercial properties", popular: true },
          { name: "3\" Trigger", description: "Service at 3 inch accumulation - budget-friendly option for lower-traffic areas" },
          { name: "On-Call / Per Request", description: "You call us when you need service - maximum flexibility, no automatic dispatches" },
          { name: "Zero Tolerance", description: "Continuous service during any snowfall - premium option for 24/7 facilities" }
        ]
      }
    },
    pricingNote: "Seasonal contracts offer the best value with unlimited service calls and priority response."
  }
];

// Company differentiators for Property Services
export const psCompanyFeatures = {
  compliance: [
    { title: "Fully Insured", description: "$5M commercial liability coverage", icon: "shield-check" },
    { title: "WCB Covered", description: "Workers' Compensation Board compliant", icon: "hard-hat" },
    { title: "Safety Plans", description: "Documented safety protocols for every job", icon: "clipboard-check" },
    { title: "COR Certified", description: "Certificate of Recognition safety program", icon: "award" }
  ],
  technology: [
    { title: "GPS Tracking", description: "Real-time vehicle and service tracking", icon: "map-pin" },
    { title: "Photo Documentation", description: "Before/after photos for every service", icon: "camera" },
    { title: "Online Portal", description: "24/7 access to service records and requests", icon: "monitor" },
    { title: "Digital Contracts", description: "Paperless agreements and invoicing", icon: "file-text" }
  ],
  network: [
    { title: "Equipment Fleet", description: "Access to additional machines when needed", icon: "truck" },
    { title: "Contractor Network", description: "Connected with local certified contractors", icon: "users" },
    { title: "24/7 Dispatch", description: "Round-the-clock emergency response", icon: "phone" },
    { title: "Local Expertise", description: "10+ years serving Central Alberta", icon: "map" }
  ]
};

// Customer portal features
export const customerPortalFeatures = [
  { title: "View Service History", description: "Complete records of all services performed on your property", icon: "history" },
  { title: "Request Services", description: "Submit new service requests anytime, anywhere", icon: "plus-circle" },
  { title: "Track Progress", description: "Real-time updates on scheduled and in-progress work", icon: "activity" },
  { title: "Photo Gallery", description: "Before and after photos of completed services", icon: "image" },
  { title: "File Complaints", description: "Easy issue reporting with automatic escalation", icon: "message-square" },
  { title: "Invoices & Payments", description: "View invoices and make payments online", icon: "credit-card" },
  { title: "Site Check Reports", description: "Daily visit logs and inspection reports", icon: "clipboard-list" },
  { title: "Insurance Documentation", description: "Download service records for insurance claims", icon: "file-check" }
];
